// import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
// import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
// import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
// import { Subject, finalize, takeUntil } from 'rxjs';
// import { AuthService } from 'src/app/services/auth.service';
// import { NotificationService } from 'src/app/services/notification.service';
// import { CommonService } from 'src/app/services/common.service';
// import { OperatoriService } from '../operatori.service';
// import { environment } from 'src/environments/environment';
// import { helper } from 'src/environments/helper';
// import { Generic } from 'src/app/interfaces/generic.interface';

// interface UserFunction {
//     functie_id: number;
//     functie_name: string;
//     is_active: boolean;
//     assigned_date?: string;
// }

// @Component({
//     selector: 'app-update-functii-multiple-operator',
//     templateUrl: './update-functii-multiple-operator.component.html',
//     styleUrls: ['./update-functii-multiple-operator.component.scss']
// })
// export class UpdateFunctiiMultipleOperatorComponent implements OnInit, OnDestroy {
//     private destroy$ = new Subject<void>();

//     errorTitle: string = environment.config.customNotifications.headers.error;
//     errorIcon: string = environment.config.customNotifications.icons.error;
//     successIcon: string = environment.config.customNotifications.icons.success;
//     helper = helper;

//     form!: FormGroup;
//     availableFunctions: Generic[] = [];
//     currentUserFunctions: UserFunction[] = [];

//     isLoading = true;
//     isSubmitting = false;

//     constructor(
//         @Inject(MAT_DIALOG_DATA) public data: any,
//         private dialogRef: MatDialogRef<UpdateFunctiiMultipleOperatorComponent>,
//         private fb: FormBuilder,
//         private notificationService: NotificationService,
//         private authService: AuthService,
//         private operatorService: OperatoriService,
//         private commonService: CommonService,
//     ) {
//         this.initializeForm();
//     }

//     ngOnInit(): void {
//         this.loadAvailableFunctions();
//         this.loadCurrentUserFunctions();
//     }

//     ngOnDestroy(): void {
//         this.destroy$.next();
//         this.destroy$.complete();
//     }

//     private initializeForm(): void {
//         this.form = this.fb.group({
//             functions: this.fb.array([]),
//             activeFunctie: new FormControl('', [Validators.required])
//         });
//     }

//     get functionsFormArray(): FormArray {
//         return this.form.get('functions') as FormArray;
//     }

//     private loadAvailableFunctions(): void {
//         this.commonService.getFunctii()
//             .pipe(
//                 takeUntil(this.destroy$),
//                 finalize(() => {
//                     // Don't set isLoading to false here, wait for user functions to load
//                 })
//             )
//             .subscribe({
//                 next: (functions: Generic[]) => {
//                     this.availableFunctions = functions;
//                     this.setupFunctionsFormArray();
//                 },
//                 error: (error) => {
//                     console.error('Error loading available functions:', error);
//                     this.notificationService.warningSwal(
//                         this.errorTitle,
//                         'Eroare la încărcarea funcțiilor disponibile',
//                         this.errorIcon
//                     );
//                 }
//             });
//     }

//     private loadCurrentUserFunctions(): void {
//         this.operatorService.getUserMultipleFunctii(this.data.id_user)
//             .pipe(
//                 takeUntil(this.destroy$),
//                 finalize(() => {
//                     this.isLoading = false;
//                 })
//             )
//             .subscribe({
//                 next: (response: any) => {
//                     this.currentUserFunctions = response.data?.functions || [];
//                     this.updateFormWithCurrentFunctions();
//                 },
//                 error: (error) => {
//                     console.error('Error loading user functions:', error);
//                     this.currentUserFunctions = [];
//                     this.updateFormWithCurrentFunctions();

//                     // Don't show error for new users without functions yet
//                     if (error.status !== 404) {
//                         this.notificationService.warningSwal(
//                             this.errorTitle,
//                             'Eroare la încărcarea funcțiilor utilizatorului',
//                             this.errorIcon
//                         );
//                     }
//                 }
//             });
//     }

//     private setupFunctionsFormArray(): void {
//         // Clear existing form array
//         while (this.functionsFormArray.length !== 0) {
//             this.functionsFormArray.removeAt(0);
//         }

//         // Add a checkbox control for each available function
//         this.availableFunctions.forEach(() => {
//             this.functionsFormArray.push(new FormControl(false));
//         });
//     }

//     private updateFormWithCurrentFunctions(): void {
//         if (this.availableFunctions.length === 0) {
//             return; // Wait for functions to load first
//         }

//         // Update checkboxes based on current user functions
//         this.availableFunctions.forEach((availableFunction, index) => {
//             const isAssigned = this.currentUserFunctions.some(
//                 uf => uf.functie_id === availableFunction.id
//             );
//             this.functionsFormArray.at(index).setValue(isAssigned);
//         });

//         // Set active function if user has one
//         const activeFunction = this.currentUserFunctions.find(uf => uf.is_active);
//         if (activeFunction) {
//             this.form.patchValue({
//                 activeFunctie: activeFunction.functie_id
//             });
//         }

//         // Update active function options
//         this.updateActiveFunctionOptions();
//     }

//     onFunctionSelectionChange(): void {
//         this.updateActiveFunctionOptions();

//         // If active function is deselected, clear it
//         const activeFunctieId = this.form.get('activeFunctie')?.value;
//         if (activeFunctieId) {
//             const selectedFunctionIds = this.getSelectedFunctionIds();
//             if (!selectedFunctionIds.includes(activeFunctieId)) {
//                 this.form.patchValue({ activeFunctie: '' });
//             }
//         }
//     }

//     private updateActiveFunctionOptions(): void {
//         const selectedFunctionIds = this.getSelectedFunctionIds();

//         // If only one function is selected, auto-select it as active
//         if (selectedFunctionIds.length === 1) {
//             this.form.patchValue({ activeFunctie: selectedFunctionIds[0] });
//         }

//         // Clear active function if no functions are selected
//         if (selectedFunctionIds.length === 0) {
//             this.form.patchValue({ activeFunctie: '' });
//         }
//     }

//     private getSelectedFunctionIds(): number[] {
//         const selectedIds: number[] = [];
//         this.functionsFormArray.controls.forEach((control, index) => {
//             if (control.value) {
//                 selectedIds.push(this.availableFunctions[index].id);
//             }
//         });
//         return selectedIds;
//     }

//     getAvailableActiveFunctions(): Generic[] {
//         const selectedIds = this.getSelectedFunctionIds();
//         return this.availableFunctions.filter(func => selectedIds.includes(func.id));
//     }

//     getFunctionDisplayName(functie: Generic): string {
//         const currentFunction = this.currentUserFunctions.find(uf => uf.functie_id === functie.id);
//         if (currentFunction) {
//             return `${functie.name} ${currentFunction.is_active ? '(Activă)' : ''}`;
//         }
//         return functie.name;
//     }

//     onSubmit(): void {
//         if (!this.form.valid) {
//             this.markFormGroupTouched();
//             return;
//         }

//         const selectedFunctionIds = this.getSelectedFunctionIds();

//         if (selectedFunctionIds.length === 0) {
//             this.notificationService.warningSwal(
//                 'Atenție',
//                 'Trebuie să selectați cel puțin o funcție pentru operator',
//                 this.errorIcon
//             );
//             return;
//         }

//         this.isSubmitting = true;

//         const payload = {
//             functie_ids: selectedFunctionIds,
//             active_functie_id: this.form.get('activeFunctie')?.value
//         };

//         this.operatorService.updateUserMultipleFunctii(this.data.id_user, payload)
//             .pipe(
//                 takeUntil(this.destroy$),
//                 finalize(() => {
//                     this.isSubmitting = false;
//                 })
//             )
//             .subscribe({
//                 next: (response) => {
//                     this.notificationService.warningSwal(
//                         helper.dialogConfig.headers.success,
//                         'Funcțiile operatorului au fost actualizate cu succes',
//                         this.successIcon
//                     );
//                     this.dialogRef.close({ success: true });
//                 },
//                 error: (error) => {
//                     console.error('Error updating user functions:', error);
//                     let errorMessage = 'Eroare la actualizarea funcțiilor operatorului';

//                     try {
//                         errorMessage = error.error?.message || errorMessage;
//                     } catch (e) {
//                         // Use default message
//                     }

//                     this.notificationService.warningSwal(
//                         this.errorTitle,
//                         errorMessage,
//                         this.errorIcon
//                     );
//                 }
//             });
//     }

//     private markFormGroupTouched(): void {
//         Object.keys(this.form.controls).forEach(key => {
//             const control = this.form.get(key);
//             control?.markAsTouched();
//         });
//     }

//     closeDialog(): void {
//         this.dialogRef.close({ success: false });
//     }

//     // Helper methods for template
//     isFormInvalid(): boolean {
//         return !this.form.valid || this.getSelectedFunctionIds().length === 0;
//     }

//     getSelectedFunctionsCount(): number {
//         return this.getSelectedFunctionIds().length;
//     }

//     hasCurrentFunction(functieId: number): boolean {
//         return this.currentUserFunctions.some(uf => uf.functie_id === functieId);
//     }

//     getCurrentFunctionStatus(functieId: number): string {
//         const currentFunction = this.currentUserFunctions.find(uf => uf.functie_id === functieId);
//         if (currentFunction?.is_active) {
//             return 'Activă';
//         } else if (currentFunction) {
//             return 'Alocată';
//         }
//         return 'Nealocată';
//     }
// }

import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { Subject, finalize, takeUntil, forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { CommonService } from 'src/app/services/common.service';
import { OperatoriService } from '../operatori.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { Generic } from 'src/app/interfaces/generic.interface';

interface UserFunction {
    functie_id: number;
    functie_name: string;
    is_active: boolean;
    assigned_date?: string;
}

@Component({
    selector: 'app-update-functii-multiple-operator',
    templateUrl: './update-functii-multiple-operator.component.html',
    styleUrls: ['./update-functii-multiple-operator.component.scss']
})
export class UpdateFunctiiMultipleOperatorComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    successIcon: string = environment.config.customNotifications.icons.success;
    helper = helper;

    form!: FormGroup;
    availableFunctions: any[] = [];
    currentUserFunctions: UserFunction[] = [];

    isLoading = true;
    isSubmitting = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private dialogRef: MatDialogRef<UpdateFunctiiMultipleOperatorComponent>,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private authService: AuthService,
        private operatorService: OperatoriService,
        private commonService: CommonService,
    ) {
        this.initializeForm();
    }

    ngOnInit(): void {
        this.loadData();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private initializeForm(): void {
        this.form = this.fb.group({
            functions: this.fb.array([]),
            activeFunctie: new FormControl('', [Validators.required])
        });
    }

    get functionsFormArray(): FormArray {
        return this.form.get('functions') as FormArray;
    }

    private loadData(): void {
        this.isLoading = true;

        // Load both available functions and user functions in parallel
        const availableFunctions$ = this.commonService.getFunctii();
        const userFunctions$ = this.operatorService.getUserMultipleFunctii(this.data.id_user);

        forkJoin({
            availableFunctions: availableFunctions$,
            userFunctions: userFunctions$
        }).pipe(
            takeUntil(this.destroy$),
            finalize(() => {
                this.isLoading = false;
            })
        ).subscribe({
            next: (response: any) => {
                // Set available functions
                this.availableFunctions = response.availableFunctions;
                console.log(this.availableFunctions);
                // Set current user functions
                this.currentUserFunctions = response.userFunctions?.data?.functions || [];

                // Setup form with both data sets available
                this.setupFormWithData();
            },
            error: (error) => {
                console.error('Error loading data:', error);

                // Try to load available functions at least
                this.loadAvailableFunctionsOnly();
            }
        });
    }

    private loadAvailableFunctionsOnly(): void {
        this.commonService.getFunctii()
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (functions: Generic[]) => {
                    this.availableFunctions = functions;
                    this.currentUserFunctions = [];
                    this.setupFormWithData();
                },
                error: (error) => {
                    console.error('Error loading available functions:', error);
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        'Eroare la încărcarea funcțiilor disponibile',
                        this.errorIcon
                    );
                }
            });
    }

    private setupFormWithData(): void {
        // Clear existing form array
        while (this.functionsFormArray.length !== 0) {
            this.functionsFormArray.removeAt(0);
        }

        // Add a checkbox control for each available function and set its value
        this.availableFunctions.forEach((availableFunction) => {
            const isAssigned = this.currentUserFunctions.some(
                uf => uf.functie_id === availableFunction.id
            );
            this.functionsFormArray.push(new FormControl(isAssigned));
        });

        // Set active function if user has one
        const activeFunction = this.currentUserFunctions.find(uf => uf.is_active);
        if (activeFunction) {
            this.form.patchValue({
                activeFunctie: activeFunction.functie_id
            });
        } else if (this.getSelectedFunctionIds().length === 1) {
            // If only one function is selected, auto-select it as active
            this.form.patchValue({
                activeFunctie: this.getSelectedFunctionIds()[0]
            });
        }

        console.log('Form setup completed:', {
            availableFunctions: this.availableFunctions.length,
            currentUserFunctions: this.currentUserFunctions.length,
            selectedFunctions: this.getSelectedFunctionIds(),
            activeFunction: this.form.get('activeFunctie')?.value
        });
    }

    onFunctionSelectionChange(): void {
        this.updateActiveFunctionOptions();

        // If active function is deselected, clear it
        const activeFunctieId = this.form.get('activeFunctie')?.value;
        if (activeFunctieId) {
            const selectedFunctionIds = this.getSelectedFunctionIds();
            if (!selectedFunctionIds.includes(activeFunctieId)) {
                this.form.patchValue({ activeFunctie: '' });
            }
        }
    }

    private updateActiveFunctionOptions(): void {
        const selectedFunctionIds = this.getSelectedFunctionIds();

        // If only one function is selected, auto-select it as active
        if (selectedFunctionIds.length === 1 && !this.form.get('activeFunctie')?.value) {
            this.form.patchValue({ activeFunctie: selectedFunctionIds[0] });
        }

        // Clear active function if no functions are selected
        if (selectedFunctionIds.length === 0) {
            this.form.patchValue({ activeFunctie: '' });
        }
    }

    private getSelectedFunctionIds(): number[] {
        const selectedIds: number[] = [];
        this.functionsFormArray.controls.forEach((control, index) => {
            if (control.value) {
                selectedIds.push(this.availableFunctions[index].id);
            }
        });
        return selectedIds;
    }

    getAvailableActiveFunctions(): Generic[] {
        const selectedIds = this.getSelectedFunctionIds();
        return this.availableFunctions.filter(func =>
            selectedIds.includes(func.id) && func.active
        );
    }

    getFunctionDisplayName(functie: Generic): string {
        const currentFunction = this.currentUserFunctions.find(uf => uf.functie_id === functie.id);
        if (currentFunction) {
            return `${functie.name} ${currentFunction.is_active ? '(Activă)' : ''}`;
        }
        return functie.name;
    }

    onSubmit(): void {
        if (!this.form.valid) {
            this.markFormGroupTouched();
            return;
        }

        const selectedFunctionIds = this.getSelectedFunctionIds();

        if (selectedFunctionIds.length === 0) {
            this.notificationService.warningSwal(
                'Atenție',
                'Trebuie să selectați cel puțin o funcție pentru operator',
                this.errorIcon
            );
            return;
        }

        this.isSubmitting = true;

        const payload = {
            functie_ids: selectedFunctionIds,
            active_functie_id: this.form.get('activeFunctie')?.value
        };

        this.operatorService.updateUserMultipleFunctii(this.data.id_user, payload)
            .pipe(
                takeUntil(this.destroy$),
                finalize(() => {
                    this.isSubmitting = false;
                })
            )
            .subscribe({
                next: (response) => {
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.success,
                        'Funcțiile operatorului au fost actualizate cu succes',
                        this.successIcon
                    );
                    this.dialogRef.close({ success: true });
                },
                error: (error) => {
                    console.error('Error updating user functions:', error);
                    let errorMessage = 'Eroare la actualizarea funcțiilor operatorului';

                    try {
                        errorMessage = error.error?.message || errorMessage;
                    } catch (e) {
                        // Use default message
                    }

                    this.notificationService.warningSwal(
                        this.errorTitle,
                        errorMessage,
                        this.errorIcon
                    );
                }
            });
    }

    private markFormGroupTouched(): void {
        Object.keys(this.form.controls).forEach(key => {
            const control = this.form.get(key);
            control?.markAsTouched();
        });
    }

    closeDialog(): void {
        this.dialogRef.close({ success: false });
    }

    // Helper methods for template
    isFormInvalid(): boolean {
        return !this.form.valid || this.getSelectedFunctionIds().length === 0;
    }

    getSelectedFunctionsCount(): number {
        return this.getSelectedFunctionIds().length;
    }

    hasCurrentFunction(functieId: number): boolean {
        return this.currentUserFunctions.some(uf => uf.functie_id === functieId);
    }

    getCurrentFunctionStatus(functieId: number): string {
        const currentFunction = this.currentUserFunctions.find(uf => uf.functie_id === functieId);
        if (currentFunction?.is_active) {
            return 'Activă';
        } else if (currentFunction) {
            return 'Alocată';
        }
        return 'Nealocată';
    }
}